import { ChatConversation } from './AiChatContext';
import { generateConversationRef } from './conversationRef';

const STORAGE_KEY = 'ai-chat-conversations';
const TTL_MS = 10 * 24 * 60 * 60 * 1000; // 10 days

export function loadConversations(): Record<string, ChatConversation> {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }

    const parsed: Record<string, ChatConversation> = JSON.parse(raw);
    const now = Date.now();
    const result: Record<string, ChatConversation> = {};

    for (const [id, conversation] of Object.entries(parsed)) {
      if (now - conversation.lastActivityAt < TTL_MS) {
        result[id] = {
          ...conversation,
          conversationRef: conversation.conversationRef || generateConversationRef(),
        };
      }
    }

    return result;
  } catch {
    return {};
  }
}

export function saveConversations(conversations: Record<string, ChatConversation>): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(conversations));
  } catch {
    // sessionStorage full or unavailable -- silently ignore
  }
}
